<template>
  <dpc-teaser-article
    v-if="['ARTICLE'].includes($extension.type)"
    :data="data"
  />
  <dpc-teaser-media v-else :data="data" />
</template>

<script>
import { computedExtensionDefaults } from './extension.mixin.js';

export default {
  mixins: [computedExtensionDefaults],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
